/* eslint-disable import/no-cycle */
/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-28 20:49:15
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-09-05 14:37:27
 * @FilePath: /roboneo-web/src/pages/--roboneo/studio/components/InfiniteCanvas/layerData.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  ElementOptions, Operation, HistoryChangeType, DeltaType, getElementOptions, FabricObject, ElementName, IText,
  isRealElement,
  LoadingText,
} from '@meitu/whee-infinite-canvas';
import useCanvasStore, { handleShowAll, setRenderedStatus } from '$/store/useCanvasStore';
import useTextEditSote, { initTextStatus } from '$/store/useTextEditSote';
import { message } from '$/components/Message';
import { setLayers } from '$/store/useLayerStore';
import {
  saveLayer, deleteLayer, fetchLayerList, initRoom,
} from '$/api/canvasRquest';
import { mtstatTrack } from '$/utils/mtstat';
import { getUrlSearchParams } from '$/utils';
import useGraphicToolStore, { initGraphicStatus } from '$/store/useGraphicToolStore';
import { ProjectType, submitRoom } from '$/api/server';
import { insertImage, insertVideo } from '$/store/useCanvasObjectStore';
import { redoCallbackSetTaskLoading } from './ImagesTask/index';

/**
 * 重置文本字段状态
 *
 * @export
 */
export function resetActiveTextStatus(ids: string[]) {
  const { render } = useCanvasStore.getState();
  const ele = render?.Finder.findById(ids[0]);
  const isText = (ele as IText)._name_ === ElementName.TEXT;
  const { activeTextStatus } = useTextEditSote.getState();
  if (activeTextStatus && isText) {
    useTextEditSote.setState((state) => {
      state.activeTextStatus = initTextStatus(ele as IText);
    });
  }
}

/**
 * 重置图层工具值
 *
 * @export
 */
export function resetActiveGraphicToolsStatus(ids: string[]) {
  const { render } = useCanvasStore.getState();
  const ele = render?.Finder.findById(ids[0]);
  const isGraphicTools = [ElementName.ARROW, ElementName.ELLIPSE, ElementName.RECTANGLE].includes((ele as FabricObject)._name_ as ElementName);
  const { activeGraphicStatus } = useGraphicToolStore.getState();
  if (activeGraphicStatus && isGraphicTools) {
    initGraphicStatus(ele as FabricObject);
  }
}

/**
 * 处理画布历史redo undo 提交项目历史参数
 *
 * @export
 * @param {{
 *   operations: Operation[];
 *   historyChangeType: HistoryChangeType;
 * }} {
 *   operations,
 *   historyChangeType,
 * }
 * @return {*}
 */
export function handleHistoryOperationsParams({
  operations,
  historyChangeType,
}: {
  operations: Operation[];
  historyChangeType: HistoryChangeType;
}) {
  const deleteOptions: ElementOptions[] = [];
  const saveOptions: ElementOptions[] = [];
  operations.forEach((operation) => {
    const objects = operation.options.preData?.objects
      ?? operation.options.afterData?.objects
      ?? [];
    if (historyChangeType === HistoryChangeType.UNDO) {
      if (operation.options.type === DeltaType.MODIFY) {
        saveOptions.push(...(operation.options.preData?.objects ?? []));
      } else if (operation.options.type === DeltaType.INSERT) {
        deleteOptions.push(...objects);
      } else if (operation.options.type === DeltaType.MERGE) {
        saveOptions.push(...(operation.options.preData?.objects ?? []));
        deleteOptions.push(...(operation.options.afterData?.objects || []));
      } else if (operation.options.type === DeltaType.SPLIT) {
        saveOptions.push(...(operation.options.preData?.objects ?? []));
        deleteOptions.push(...(operation.options.afterData?.objects || []));
      } else {
        saveOptions.push(...objects);
      }
    } else if (historyChangeType === HistoryChangeType.REDO) {
      if (operation.options.type === DeltaType.MODIFY) {
        saveOptions.push(...(operation.options.afterData?.objects ?? []));
      } else if (operation.options.type === DeltaType.DELETE) {
        deleteOptions.push(...objects);
      } else if (operation.options.type === DeltaType.MERGE) {
        saveOptions.push(...(operation.options.afterData?.objects ?? []));
        deleteOptions.push(...(operation.options.preData?.objects || []));
      } else if (operation.options.type === DeltaType.SPLIT) {
        saveOptions.push(...(operation.options.afterData?.objects ?? []));
        deleteOptions.push(...(operation.options.preData?.objects || []));
      } else {
        saveOptions.push(...objects);
      }
    }
  });
  return { deleteOptions, saveOptions };
}

/**
 * 保存画布数据
 * @export
 * @param {ElementOptions[]} options
 * @return {*}
 */

let isFirstSave = true;

/**
 * 只读画布不保存图层，也不提交房间变更。
 */
export function saveLayerData(options: ElementOptions[] | null, objects?: FabricObject[]) {
  if (useCanvasStore.getState().readonly) return;
  if (options) {
    options = options.map((item) => {
      if ('_mask_options_' in item) {
        const { _mask_options_, ...reset } = item;
        return reset;
      }
      return item;
    });
  }
  const searchParams = getUrlSearchParams();
  const room_id = searchParams.get('room_id');
  if (!room_id) return;

  const { render } = useCanvasStore.getState();
  const _options = objects?.map((op) => {
    return getElementOptions.call(render!, op, {
      maskOptions: false,
    });
  }) || [];
  const layers = (options || _options).map((op) => {
    return {
      layer_id: op._id_,
      editor_params: JSON.stringify(op),
    };
  });

  // 先调用保存接口
  saveLayer({ room_id, layers })
    .then(async () => {
      // 如果是第一次保存，则提交房间信息
      if (isFirstSave) {
        isFirstSave = false;
        await submitRoom({ room_id, room_type: ProjectType.Canvas });
      }
    });
}

/**
 * 删除画布数据
 *
 * @export
 * @param {ElementOptions[]} options
 * @return {*}
 */
export function deleteLayerData(options: ElementOptions[] | null, objects?: FabricObject[]) {
  if (useCanvasStore.getState().readonly) return;
  const searchParams = getUrlSearchParams();
  const room_id = searchParams.get('room_id');
  if (!room_id) return;
  const { render } = useCanvasStore.getState();
  const _options = objects?.map((op) => {
    return getElementOptions.call(render!, op);
  }) || [];
  const layer_ids = (options || _options).map((op) => op._id_).join(',');
  deleteLayer({ room_id, layer_ids });
}

/**
 * 历史记录修改回调
 *
 * @export
 * @param {Operation} operation
 */
export function onInteractionModifiedCallback(operation: Operation) {
  const objects = operation.options.afterData?.objects || [];
  saveLayerData(objects);
}

/**
 * 历史记录回退回调
 *
 * @export
 * @param {Operation[]} operations
 */
export function undoChangeCallback(operations: Operation[]) {
  const { saveOptions, deleteOptions } = handleHistoryOperationsParams({
    operations,
    historyChangeType: HistoryChangeType.UNDO,
  });
  saveOptions.length && saveLayerData(saveOptions);
  deleteOptions.length && deleteLayerData(deleteOptions);
  const ids = saveOptions.map((item) => item._id_);
  resetActiveTextStatus(ids);
  resetActiveGraphicToolsStatus(ids);
}

/**
 * 历史记录前进回调
 *
 * @export
 * @param {Operation[]} operations
 */
export function redoChangeCallback(operations: Operation[]) {
  const { saveOptions, deleteOptions } = handleHistoryOperationsParams({
    operations,
    historyChangeType: HistoryChangeType.REDO,
  });
  saveOptions.length && saveLayerData(saveOptions);
  deleteOptions.length && deleteLayerData(deleteOptions);
  const ids = saveOptions.map((item) => item._id_);
  redoCallbackSetTaskLoading(ids);
  resetActiveTextStatus(ids);
  resetActiveGraphicToolsStatus(ids);
}

function canvasResourceLoadTrack(room_id: string, els: FabricObject[], t: number) {
  let video_num = 0;
  let text_num = 0;
  let image_num = 0;
  function _countElLoop(objects: FabricObject[]) {
    for (const el of objects) {
      if (isRealElement(el)) {
        if (el._name_ === ElementName.VIDEO) {
          video_num += 1;
        }
        if (el._name_ === ElementName.IMAGE) {
          image_num += 1;
        }
        if (el._name_ === ElementName.TEXT) {
          text_num += 1;
        }
        if (el._name_ === ElementName.CONTAINER) {
          // @ts-ignore
          _countElLoop(el.children);
        }
      }
    }
  }

  _countElLoop(els);

  const total_num = video_num + image_num + text_num;

  const load_time = Date.now() - t;
  const params = {
    room_id,
    load_time,
    total_num,
    video_num,
    text_num,
    image_num,
  };
  console.info('画布资源加载埋点参数', params);
  mtstatTrack('canvas_resource_load', params);
}

/**
 * 获取画布数据
 *
 * @export
 */
export async function getLayers(readonly = false) {
  const hide = message.loading('RoboNeo_Web_studio_loading_text', 0);

  try {
    const { render } = useCanvasStore.getState();
    const searchParams = getUrlSearchParams();
    const roomId = searchParams.get('room_id');
    const fromRoomId = searchParams.get('from_room_id') ?? undefined;
    if (roomId && render) {
      if (!readonly) await initRoom(roomId, fromRoomId);
      const res = await fetchLayerList(roomId);
      if (res.list.length) {
        const sceneList = res.list.map((item) => {
          return JSON.parse(item.params);
        });
        // 兼容老数据 接入 infinite-canvas video/dynamic-picture
        sceneList.forEach((item) => {
          if (item.frameType) {
            if (item.frameType === ElementName.VIDEO) {
              item._name_ = ElementName.VIDEO;
            } else {
              item._name_ = ElementName.DYNAMIC_PICTURE;
            }
          }
        });
        console.warn('sceneList', sceneList);
        console.time('setSceneDataBySync');
        const t = Date.now();
        const els = render?.setSceneDataBySync(sceneList);
        // 资源加载埋点
        canvasResourceLoadTrack(roomId, els, t);
        console.timeEnd('setSceneDataBySync');
        render._FC.discardActiveObject();
        const objects = render._FC.getObjects();
        setLayers(objects);
        handleShowAll();
      }
      setRenderedStatus('success');
      hide();
    }
  } catch (error) {
    hide();
    message.error('roboneo_web_canvas_loading_failed');
    setRenderedStatus('failed');
    console.log('fetchLayerList error', error);
  }
}

export async function setLayerLoading(...targets: Array<LoadingText>) {
  const { render } = useCanvasStore.getState();
  render?.Actions.setLoading(...targets);
}
